import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Row, Col, Panel} from 'react-bootstrap';
import FeedbackChainControlPanel from './FeedbackChainControlPanel';
import FeedbackChainCommentsArea from './FeedbackChainCommentsArea';
import FeedbackChain from './FeedbackChain';

@injectIntl @inject('rootStore','feedbackChainsStore', 'feedbackCommentsStore') @observer
export default class Show extends React.Component{

    render() {
        // Improve
        const feedbackChain = this.props.feedbackChainsStore.getFeedbackById(this.props.feedbackChainId);
        const {intl} = this.props;
        if( this.props.feedbackChainsStore.loading ){
            return (
                <div className='form-container text-center'>
                    <div className="main-loader">
                        <div className="loader-lg"></div>
                    </div>
                    <span>{intl.formatMessage({id: 'loading'})}</span>
                </div>
            );
        }
        return (
            <Row>
                <Col xs={12}>
                    <div className="FeedbackChain">
                        <Row >
                            <Col xs={12} md={8} className="pull-right">
                                <Panel className={'border-top border-top-2'}>
                                    <FeedbackChain feedbackChain={feedbackChain} />
                                    <FeedbackChainCommentsArea feedbackChain={feedbackChain} />
                                </Panel>
                            </Col>
                            <Col xs={12} md={4} className="pull-right">
                                <Panel className={'border-top border-top-2'}>
                                    <FeedbackChainControlPanel feedbackChain={feedbackChain} />
                                </Panel>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        );
    }

}